import { render, staticRenderFns } from "./UserAgentsTab.vue?vue&type=template&id=2576f79e"
import script from "./UserAgentsTab.vue?vue&type=script&lang=js"
export * from "./UserAgentsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports